const DAY_IN_MS = 24 * 60 * 60 * 1000; // 24 часа в миллисекундах

export const getModalDisplayedTimes = (name: string, ttl: number = DAY_IN_MS): number => {
  try {
    const dataRaw = localStorage.getItem(name);
    const now = Date.now();

    if (dataRaw) {
      const data = dataRaw.split(';');

      const timestamp = Number(data[0]);
      const count = Number(data[1]);

      // Если прошло более суток — удаляем запись
      if (now - timestamp >= ttl) {
        localStorage.removeItem(name);

        return 0;
      } else {
        localStorage.setItem(name, [timestamp, count + 1].join(';'));

        return count;
      }
    } else {
      localStorage.setItem(name, [now, 1].join(';'));

      return 0;
    }
  } catch (e) {
    return 0;
  }
};
